import axios from 'axios';
import { baseUrl } from '../utils/baseUrl';

export const api = axios.create({
  baseURL: `${baseUrl}/api`,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default api;
